import React from 'react';
import '../css/Objective.css';

const Objective: React.FC = () => {
    return (
        <div className="objective">
            <div className="objective-content">
                <div
                    className="objective-img-block"
                    style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL + '/image3.jpg'})`,
                        backgroundColor: `rgba(0, 0, 0, 0.5)`,
                        backgroundBlendMode: 'multiply',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundOrigin: 'content-box',
                        backgroundPosition: 'bottom',
                        overflow: 'hidden',
                    }}
                ></div>
                <div className="objective-title-block">
                    {' '}
                    <div className="objective-title">
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Objectives and Growth Strategy</div>
                        <div style={{ fontWeight: 'bold' }}>목표 및 성장 전략</div>
                        <br />
                        ──────
                        <br />
                    </div>
                    <div className="objective-description">
                        오랜 시간 검증된 외환거래 노하우를 실전 트레이딩에 도입하여
                        <br />
                        안정적이고 누구나 쉽게 수익을 낼 수 있는 체계적인 시스템을 제공합니다.
                        <br />
                        전 세계 외환거래에 관심이 있는 개인 투자자들을 대상으로 <br />
                        아카데미 교육을 통해 지속적으로 수익을 창출합니다.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Objective;
